export const extractTenantFromSubdomain = () => {
  const hostname = window.location.hostname;
  
  // Handle localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // You can set a default tenant for development or get it from env
    return 'default-6hous';
  }

  // Extract subdomain from hostname
  const parts = hostname.split('.');
  if (parts.length > 2) {
    console.log(parts[0]);
    if (parts[0] === 'ergoman') {
      return 'ergoman-fang8';
    }
    return parts[0];
  }

  throw new Error('No tenant subdomain found');
};

export const getTenantConfig = (tenantId) => {


  return {
    apiKey: "AIzaSyCASsk1q1m-TSa-8Ahk5fFAhw4EmIVrzqc",
    authDomain: "document-management-449311.firebaseapp.com",
    projectId: "document-management-449311",
    storageBucket: "gs://document-management-449311.firebasestorage.app",
    messagingSenderId: "517325842627",
    appId: "1:517325842627:web:92064f7462dfb23b2e1a76",
    measurementId: "G-CP1MQSX6NV"
  };
}; 